import { ChartOfAccountsHelpAnchor } from './chart-of-accounts-help-anchor.enum';
import { JournalReversalCodeLinks } from './journal-reversal-code-links.constant';
import { ImportType } from '../data/enums/import-type.enum';

let vm;
export class HelpCenterUrlService {
    private baseUrl: string;

    static $inject: string[] = [
        'Settings',
    ];

    constructor() {
        vm = this;
        vm.baseUrl = 'https://help.buildium.com/hc/s';

        vm.getHelpCenterUrl = () => {
            return vm.baseUrl;
        };

        vm.getSubmitSupportTicketUrl = () => {
            return `${vm.baseUrl}/contactsupport`;
        };

        vm.getSearchUrl = (searchTerm: string) => {
            return `${vm.baseUrl}/global-search/${encodeURIComponent(searchTerm)}`;
        };

        vm.getChartOfAccountsUrl = (anchor: ChartOfAccountsHelpAnchor) => {
            const chartOfAccountArticle = `${vm.baseUrl}/article/Chart-of-accounts-and-account-types`;
            let anchorTag = '';
            switch (anchor) {
                case ChartOfAccountsHelpAnchor.AccountType:
                    anchorTag = '#accounttype';
                    break;
                case ChartOfAccountsHelpAnchor.AccountNumber:
                    anchorTag = '#accountnumbers';
                    break;
                case ChartOfAccountsHelpAnchor.AddingAccounts:
                    anchorTag = '#howtoaddtochart';
                    break;
                case ChartOfAccountsHelpAnchor.DefaultAccounts:
                    anchorTag = '#defaultaccounts';
                    break;
                case ChartOfAccountsHelpAnchor.ImportingAccounts:
                    anchorTag = '#importchartofaccount';
                    break;
                case ChartOfAccountsHelpAnchor.EditExistingAccounts:
                    anchorTag = '#updateexisting';
                    break;
                case ChartOfAccountsHelpAnchor.MovingTransactions:
                    anchorTag = '#movingtransactions';
                    break;
                case ChartOfAccountsHelpAnchor.DeletingItems:
                    anchorTag = '#deleteanitem';
                    break;
                case ChartOfAccountsHelpAnchor.InactivatingAccounts:
                    anchorTag = '#inactivateaccount';
                    break;
                case ChartOfAccountsHelpAnchor.RemovingAccountNumbers:
                    anchorTag = '#removeaccountnumber';
                    break;
                default:
                // do nothing
            }

            return `${chartOfAccountArticle}${anchorTag}`;
        };

        vm.getLockingAccountBooksUrl = () => {
            return `${vm.baseUrl}/article/Locking-your-accounting-books`;
        };

        vm.getResidentCenterReminderUrl = () => {
            return `${vm.baseUrl}/article/Automated-Resident-Reminders`;
        };

        vm.getRentersInsuranceRemindersUrl = () => {
            return `${vm.baseUrl}/article/Resident-Reminders-for-Renters-Insurance`;
        };

        vm.getAvailableCashUrl = () => {
            return `${vm.baseUrl}/article/Available-Cash-Explained-1557492524154`;
        };

        vm.getRentAndRentHistoryUrl = () => {
            return `${vm.baseUrl}/article/Rent-and-Rent-History`;
        };

        vm.getAutomatedEmailSettingsUrl = () => {
            return `${vm.baseUrl}/article/Automated-Email-Settings`;
        };

        vm.getMovePrepaymentsUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-move-prepayments-to-the-automated-general-ledger-account-1557495181444`;
        };

        vm.getJournalReversalCodeUrl = (memo: string) => {
            const url = JournalReversalCodeLinks.filter(link => memo.indexOf(link.Id) !== -1);

            if (!url || !url.length) {
                return null;
            }
            return url[0].Link;
        };

        vm.getImportUrl = (importType?: ImportType) => {
            let url = `${vm.baseUrl}/article/Import-data-into-Buildium`;

            switch (importType) {
                case ImportType.Payment:
                    url = `${vm.baseUrl}/article/How-do-I-use-payment-coupons-and-lockbox-files-in-Buildium`;
                    break;
                case ImportType.Tenant:
                    url = `${vm.baseUrl}/article/Data-Import-Tenants-and-leases`;
                    break;
                case ImportType.AssociationOwner:
                    url = `${vm.baseUrl}/article/Data-Import-Association-Owners`;
                    break;
                case ImportType.Rentalowner:
                    url = `${vm.baseUrl}/article/Data-Import-Rental-Owners`;
                    break;
                case ImportType.Vendor:
                    url = `${vm.baseUrl}/article/Data-Import-Vendors`;
                    break;
                case ImportType.PaymentAndCharge:
                    url = `${vm.baseUrl}/article/Data-Import-Charges-and-Payments`;
                    break;
                case ImportType.CheckAndDeposit:
                    url = `${vm.baseUrl}/article/Data-Import-Checks-and-Deposits`;
                    break;
                case ImportType.Rentals:
                    url = `${vm.baseUrl}/article/Data-Import-Rental-properties-and-units`;
                    break;
                case ImportType.Associations:
                    url = `${vm.baseUrl}/article/Data-Import-Associations-and-units`;
                    break;
                case ImportType.Bills:
                case ImportType.StrongroomPayments:
                    url = `${vm.baseUrl}/article/Strongroom`;
                    break;
                case ImportType.UnpaidBills:
                    url = `${vm.baseUrl}/article/Unpaid-Bill-Import`;
                    break;
                case ImportType.ChartOfAccounts:
                    url = `${vm.baseUrl}/article/Chart-of-accounts-and-account-typesS#HowToImportChart`;
                    break;
                case ImportType.CustomFieldRentals:
                case ImportType.CustomFieldRentalUnits:
                case ImportType.CustomFieldAssociations:
                case ImportType.CustomFieldAssociationUnits:
                case ImportType.CustomFieldAssociationOwners:
                case ImportType.CustomFieldAssociationTenants:
                case ImportType.CustomFieldVendors:
                case ImportType.CustomFieldLeases:
                case ImportType.CustomFieldRentalOwners:
                case ImportType.CustomFieldOwnershipAccounts:
                    url = `${vm.baseUrl}/article/Importing-Custom-Field-Values`;
                    break;
                default:
                // do nothing
            }
            return url;
        };

        vm.getEpayGettingStartedUrl = () => {
            return `${vm.baseUrl}/article/Getting-started-with-ePay`;
        };

        vm.getBankReconciliationUrl = () => {
            return `${vm.baseUrl}/article/Reconciling-a-bank-account-manually`;
        };

        vm.getListingSyndicationUrl = () => {
            return `${vm.baseUrl}/article/Buildiums-rental-listing-syndication-partners`;
        };

        vm.getEpayBasicsUrl = () => {
            return `${vm.baseUrl}/article/ePay-BasicS`;
        };

        vm.getMovingMoneyBetweenPropertiesUrl = () => {
            return `${vm.baseUrl}/article/Moving-Money-Between-Properties`;
        };

        vm.getUnfollowTextThreadUrl = () => {
            return `${vm.baseUrl}/article/Unfollow-a-text-thread`;
        };

        vm.getBatchedReportingUrl = () => {
            return `${vm.baseUrl}/article/Reports-available-for-batched-reporting`;
        };

        vm.getManagingLeaseTemplatesUrl = () => {
            return `${vm.baseUrl}/article/Creating-and-Managing-Lease-Templates-for-eSignature-how-to`;
        };

        vm.getCreateLeaseTemplatesUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-create-lease-templates-for-eLease`;
        };

        vm.getStrongroomUrl = () => {
            return `${vm.baseUrl}/article/Strongroom`;
        };

        vm.getHelloSignUrl = () => {
            return `${vm.baseUrl}/article/esignature-for-leasing`;
        };

        vm.getTrustAccountingWarningUrl = () => {
            return `${vm.baseUrl}/article/Troubleshooting-Trust-Accounting-Warnings`;
        };

        vm.getRentalOwnerEpayUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-add-rental-owner-ePay-information`;
        };

        vm.getInvitingResidentsChecklistUrl = () => {
            return `${vm.baseUrl}/article/A-Checklist-for-inviting-Residents-and-Association-Owners-to-the-Resident-Center`;
        };

        vm.getInvitingRentalOwnersChecklistUrl = () => {
            return `${vm.baseUrl}/article/A-Checklist-for-inviting-Rental-Owners-to-the-Owner-Portal`;
        };

        vm.getOpsTechUrl = () => {
            return `${vm.baseUrl}/article/Automated-Invoice-Entry-powered-by-OpsTechnology`;
        };

        vm.getPrioritySupportUrl = () => {
            return `${vm.baseUrl}/article/What-is-Priority-Support`;
        };

        vm.getPremiumTenantScreeningUrl = () => {
            return `${vm.baseUrl}/article/Premium-Tenant-ScreeninG`;
        };

        vm.getTwoPhasedScreeningUrl = () => {
            return `${vm.baseUrl}/article/Two-Phased-Screening`;
        };

        vm.getDeleteUnitUrl = () => {
            return `${vm.baseUrl}/article/Can-I-inactivate-or-delete-a-unit-from-a-rental-property`;
        };

        vm.getInactivateRentalPropertyUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-inactivate-a-rental-property`;
        };

        vm.getTenantPaymentReminderUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-send-payment-reminder-emails-to-tenants-automatically`;
        };

        vm.getViolationsUrl = () => {
            return `${vm.baseUrl}/article/Violation-Tracking-in-Buildium`;
        };

        vm.getPayOutManagementAccountUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-pay-out-management-income-accounts-to-my-company-1557495011081`;
        };

        vm.getIntroducingHelloSignUrl = () => {
            return `${vm.baseUrl}/article/Introducing-New-Lease-Templates-and-how-to-prepare-for-eSignature`;
        };

        vm.getPreparingForHelloSignUrl = () => {
            return `${vm.baseUrl}/article/What-to-do-before-enabling-HelloSign-in-your-Buildium-account`;
        };

        vm.getRentReportingUrl = () => {
            return `${vm.baseUrl}/article/Rent-Reporting-FAQs`;
        };

        vm.getTaxFilingsUrl = () => {
            return `${vm.baseUrl}/article/Form-1099-Overview-and-FAQQ`;
        };

        vm.getUseTaskUrl = () => {
            return `${vm.baseUrl}/article/How-to-use-Tasks`;
        };

        vm.getUseWorkOrderUrl = () => {
            return `${vm.baseUrl}/article/How-to-use-work-orders`;
        };

        vm.getHowToEnterBillsUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-enter-bills-into-Buildium`;
        };

        vm.getHowToPayBillsUrl = () => {
            return `${vm.baseUrl}/article/How-do-I-pay-bills-1557495177756`;
        };

        vm.getUseProjectsUrl = () => {
            return `${vm.baseUrl}/article/FAQ-Maintenance-Projects`;
        };
    }
}
